module.exports = __webpack_public_path__ + "static/media/linkchimp-social.e08a8cc0.jpg";